import { render } from "./PageNumber8.vue?vue&type=template&id=5a948aac&scoped=true"
import script from "./PageNumber8.vue?vue&type=script&lang=js"
export * from "./PageNumber8.vue?vue&type=script&lang=js"

import "./PageNumber8.vue?vue&type=style&index=0&id=5a948aac&scoped=true&lang=css"

import exportComponent from "/home/alex/Documents/EVO/investorpresentation/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a948aac"]])

export default __exports__